<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<a id="title6"><h1 class="title"><em class="i">Section 1</em></h1>
<h1 class="subtitle"><strong class="b">THE CAUSES OF POVERTY</strong></h1>
</a></div><a id="title6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783830763_p01.vue?2c4185a9